import styled from '@emotion/styled';
import {useState, useEffect} from 'react';

const StyledWrapper = styled.div<{showOutline: boolean}>`
  position: relative;
  flex-grow: 1;

  ${({showOutline, theme}) =>
    showOutline &&
    theme.isAccessibleTheme &&
    `
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      outline: 2px dashed ${theme.colors.focusState};
      outline-offset: 2px;
      pointer-events: none;
    }
  `}
`;

export const AccessibleSelectWrapper = ({children, ...props}: any) => {
  const [isKeyboardUser, setIsKeyboardUser] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const handleKeyDown = () => setIsKeyboardUser(true);
    const handleMouseDown = () => setIsKeyboardUser(false);

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  const showOutline = isKeyboardUser && isFocused;

  return (
    <StyledWrapper
      showOutline={showOutline}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      {...props}
    >
      {children}
    </StyledWrapper>
  );
};
